import script from "./VergleichLuecke.vue?vue&type=script&setup=true&lang=js"
export * from "./VergleichLuecke.vue?vue&type=script&setup=true&lang=js"

import "./VergleichLuecke.vue?vue&type=style&index=0&id=55d1d354&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55d1d354"]])

export default __exports__